<mat-list-item line="none">
	<mat-autocomplete
		[(ngModel)]="autocomplete.input"
		(ionInput)="updateSearchResults()"
		placeholder="Search for a place"
		ngDefaultControl>
	</mat-autocomplete>
</mat-list-item>

<mat-list [hidden]="autocompleteItems.length == 0">
	@for (item of autocompleteItems; track item) {
<mat-list-item
	
		tappable
		(click)="selectSearchResult(item)">
		{{ item.description }}
	</mat-list-item>
}
</mat-list>

<div
	#mapContainer
	id="map"></div>
